import instance from "./instance";

const ObligationApi = (params) => {
  return instance.get(`/obligasi?${params}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default ObligationApi;
